module.exports = __webpack_public_path__ + "static/media/reports_schedule_summary_report.0a573ef6.mov";